import { api } from 'src/boot/axios'

export default {
  signUp (data) {
    return api.post(`/users`, data)
  },
  otpRequest (data) {
    return api.post(`/sessions`, data)
  },
  otpCheck (data, options = {}) {
    return api.patch(`/sessions/current`, data, options)
  },
  signOut () {
    return api.delete(`/sessions/current`)
  },
  fetchProfile (options = {}) {
    return api.get(`/users/me`, {
      ...options,
      cache: false
    })
  },
  updateProfile (options = {}) {
    return api.patch(`/users/me`, options)
  },
  fetchSitesList (query = { limit: 99 }) {
    return api.get(`/sites`, {
      // params: query
      // TODO: improve this hardcoded piece
      params: {
        ...query,
        type: 'DineTime'
      }
    })
  },
  getReservationsAvailability (sid, query = {}, options) {
    return api.get(`/sites/${sid}/reservations/availability`, {
      params: query,
      ...options
    })
  },
  createReservation (sid, data = {}) {
    return api.post(`/sites/${sid}/reservations`, data)
  },
  // fetchReservations (options = {}) {
  //   return api.get(`/reservations`, options)
  // },
  fetchReservationsList (options = {}) {
    return api.get(`/users/me/reservations`, options)
  },
  fetchReservation (sid, conf, options = {}) {
    return api.get(`/sites/${sid}/reservations/${conf}`, options)
  },
  cancelReservation (sid, conf, options = {}) {
    return api.delete(`/sites/${sid}/reservations/${conf}`, options)
  },
  updateReservation (sid, conf, data = {}, options = {}) {
    return api.patch(`/sites/${sid}/reservations/${conf}`, data, options)
  }
}
